import React, { useEffect, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { useCollect } from 'hooks';

import DayJs from 'utils/Dayjs';

import Show from 'components/Show';
import Avatar from 'components/Misc/Avatar';
import { Button } from 'components/Misc/Form';
import Progress from 'components/Misc/Progress';
import Container from 'components/Misc/Container';
import { Title } from 'components/Misc/Typography';


import { useAppStore } from 'store/useAppStore';

const Profile = () => {
	// Cache current object's id
	const { id } = useParams();

	// Use app's store
	const setTitle = useAppStore(state => state.setTitle);

	// Store request parameters
	const parameters = useMemo(() => ({
		eager: 'user'
	}), []);

	// Store requested log
	const [[log, progress], collect] = useCollect(`logs/${id}`, parameters);

	// Set page's title
	useEffect(() => setTitle(log?.title), [log]);

	// Collect log on mount and on parameter change
	useEffect(() => {
		(async () => await collect())();
	}, [collect]);

	return (
		<Container className="p-4 space-y-4">
			{/* Show progress */}
			<Progress progress={progress} />

			{/* Show collected log */}
			<Show if={log?.id && !progress}>
				{/* Article's information */}
				<Title
					title={log?.module}
					subtitle={DayJs(log?.createdAt).format('DD. MMM, YYYY - HH:mm')}
					className="text-xl"
				/>

				{/* User's information */}
				<Show if={log?.user?.id}>
					<div className="flex justify-start items-center gap-4">
						<Avatar
							alt={log?.user?.fullName}
							src={log?.user?.avatar}
						/>

						<Title
							title={log?.user?.fullName}
							subtitle={log?.user?.status}
							className="whitespace-nowrap text-ellipsis overflow-hidden"
						/>

						<Button
							small
							square
							icon="link"
							to={`/users/${log?.user?.id}`}
						/>
					</div>
				</Show>

				{/* Article's preamble if present */}
				<Show if={log?.message}>
					<div className="text-neutral-800 dark:text-white leading-relaxed">
						{log?.message}
					</div>
				</Show>

				{/* Article's preamble if present */}
				<Show if={log?.stack}>
					<div className="text-sm text-neutral-800 dark:text-white leading-relaxed font-mono break-words">
						{log?.stack}
					</div>
				</Show>
			</Show>
		</Container>
	);
};

export default Profile;